/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useState } from 'react';
import DatePickerLib, { registerLocale } from 'react-datepicker';
import Styles from './DatePicker.css';
import ptbr from 'date-fns/locale/pt-BR';
import { CustomDateHeader } from './Custom/CustomDateHeader';
import { CustomDateContainer } from './Custom/CustomDateContainer';
import TextField from '../TextField/TextField';
import { maskDate } from '../../shared/utils/masks';
import ClickAwayListener from 'react-click-away-listener';

function DatePicker({
  value,
  onChange,
  error,
  completed,
  className,
  datePickerProps,
  disabled,
  textFieldProps,
  onClose,
}) {
  const [open, setOpen] = useState(false);

  const RenderCustomHeader = (props) => (
    <CustomDateHeader datePickerProps={datePickerProps} {...props} />
  );

  useEffect(() => {
    registerLocale('pt-BR', ptbr);
  }, []);

  useEffect(() => {
    if (disabled && open) {
      setOpen(false);
    }
  }, [disabled, open]);

  useEffect(() => {
    if (!open && onClose) {
      onClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <ClickAwayListener
      onClickAway={() => {
        setOpen(false);
      }}
    >
      <div
        className="clickway-datepicker"
        onClick={() => {
          setOpen(true);
        }}
      >
        <TextField
          {...textFieldProps}
          type="text"
          maskFunction={maskDate}
          endAdornment={<img src="assets/rastreadores/ic_calendar.svg" alt="" />}
          inputMode="numeric"
          onChange={null}
          readOnly
        />

        {open && (
          <div className="sn-datepicker-inline">
            <DatePickerLib
              {...datePickerProps}
              disabled={disabled}
              inline
              selected={value}
              onChange={(ev) => {
                if (!onChange) return;

                onChange(ev);
              }}
              locale="pt-BR"
              dateFormat="dd/MM/yyyy"
              className={[
                !!error ? 'input-has-error' : '',
                completed ? 'input-completed' : '',
                className,
              ].join(' ')}
              formatWeekDay={(date) => date.slice(0, 1).toUpperCase()}
              calendarContainer={CustomDateContainer}
              renderCustomHeader={RenderCustomHeader}
            />
          </div>
        )}

        <style jsx>{Styles}</style>
      </div>
    </ClickAwayListener>
  );
}

export default DatePicker;
